import { GET_ALL_CONTRACTORS } from "./types";

const ContractorsReducer = (state, action) => {
    const { type, payload } = action;
    switch (type) {
        case GET_ALL_CONTRACTORS:
            return {
                ...state,
                contractors: payload,
                wasFetched: true
            }
        default:
            return state
    }
}

export default ContractorsReducer